import React from 'react';

// redux

import { userInfoSelector } from "../../../../redux/selectors/auth";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import CustomToolbar from "../../../global/CustomToolbar";

import './LizAccounting.css'

import {
  Button,Grid, Typography, Box, DialogTitle, Dialog, DialogContent, TextField, DialogActions,
} from "@material-ui/core";
import axios from "axios";
import {BASE_URL} from "../../../global/Server/endpoints";
import InvestorPanel from "./InvestorPanel";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import { startOfMonth, endOfMonth, addDays ,format} from 'date-fns';
import withShipment from "../../../../withShipment";
import FolderCard from "./FolderCard";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import FeedbackBar from "../../../feedbackBar/FeedbackBar";
import AssessmentIcon from '@mui/icons-material/Assessment';
import ProfitSummary from "./profitSummary/ProfitSummary";
import {MONTHS} from "../atm/constant";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from '@material-ui/icons/Visibility';
import RefreshIcon from "@material-ui/icons/Refresh";


class LizAccounting extends React.Component {
  constructor(props) {
    super(props);


    const startYear = 2025;
    const currentYear = new Date().getFullYear();

    const YEARS = [];
    for (let year = startYear; year <= currentYear; year++) {
      YEARS.push(year);
    }

    this.state = {
      YEARS,
      adjustments: [],
      adjustmentForm: { description: '', type: 'ADD', amount: '' },
      showAdjustments: false,
      locations: [],
      weeklyProfits: [],
      allLocationSummary: [],

      ericProfitShares: [],
      ericAdditions: [],
      ericSubtractions: [],

      lizProfitShares: [],
      lizAdditions: [],
      lizSubtractions: [],

      unassignedAdditions: [], // all session additions combined
      unassignedSubtractions: [], // all session deductions combined
      unassignedOthers: [],

      manualDialogOpen: false,
      manualType: "ADD",
      manualDescription: "",
      manualAmount: "",
      selectedInvestor: null,

      selectedYear: null,
      selectedMonth: null,
      selectedWeek: null, // { weekNumber, fromDate, toDate }

      weeklyData: null, // loaded OR fetched data

      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',

      isProfitSummary: false,
      isEditMode: false,

      ericExtra: { atm: 0, owes: 0 },
      lizCashInHand: 0,

       refreshDialogOpen: false,
         savedEricAdditions: [],
  savedLizAdditions: [],
  savedEricSubtractions: [],
  savedLizSubtractions: [],

    };



  }

  async componentDidMount() {
    await this.fetchLocations();

    const result = this.getLastCompletedAccountingWeek();

    if (!result) return;

    const { year, monthIndex, week } = result;

    this.setState(
        {
          selectedYear: year,
          selectedMonth: monthIndex,
        },
        async () => {
          await this.openWeek(week);
        }
    );

  }

  sumAmounts = (arr = []) =>
      arr.reduce((sum, a) => sum + (Number(a.amount) || 0), 0);

  getEricBaseSubtotal = (ericProfitShares) =>
      ericProfitShares.reduce((s, p) => s + p.amount, 0) +
      this.sumAmounts(this.state.ericAdditions) -
      this.sumAmounts(this.state.ericSubtractions);

  getEricFinalTotals = (ericProfitShares, ericExtra = this.state.ericExtra) => {
    const SAMM = 450;
    const atmFromProfit = Number(ericExtra.atm || 0);
    const owesATM = Number(ericExtra.owes || 0);

    const baseSubtotal = this.getEricBaseSubtotal(ericProfitShares);
    const subTotal = baseSubtotal - SAMM - atmFromProfit;
    const total = subTotal - owesATM;

    return { baseSubtotal, subTotal, total, SAMM };
  };

  generateWeeksForMonth = (year, monthIndex) => {
    const weeks = [];
    let date = startOfMonth(new Date(year, monthIndex));

    // move to first Tuesday (Feb 3 for Feb 2026)
    while (date.getDay() !== 2) {
      date = addDays(date, 1);
    }

    let week = 1;
    while (date <= endOfMonth(new Date(year, monthIndex))) {
      const fromDate = new Date(date); // This remains Feb 3
      const toDate = addDays(fromDate, 6); // This remains Feb 9

      weeks.push({
        weekNumber: week,
        fromDate,
        toDate,
        // We subtract 1 day ONLY for the display label
        label: `Week ${week} (${format(addDays(fromDate, -1), 'MMM d')}–${format(addDays(toDate, -1), 'd')})`
      });

      week++;
      date = addDays(date, 7);
    }

    return weeks;
  }

  getLastCompletedAccountingWeek = () => {
    const today = new Date();

    // Check current month first
    let year = today.getFullYear();
    let monthIndex = today.getMonth();

    for (let i = 0; i < 12; i++) {
      const weeks = this.generateWeeksForMonth(year, monthIndex);

      const lastWeek = [...weeks]
          .reverse()
          .find(w => w.toDate < today);

      if (lastWeek) {
        return { year, monthIndex, week: lastWeek };
      }

      // Move to previous month
      monthIndex--;
      if (monthIndex < 0) {
        monthIndex = 11;
        year--;
      }
    }

    return null;
  };

  openWeek = async (week) => {
    const { selectedYear, selectedMonth, locations } = this.state;

    this.setState({
      selectedWeek: week,
      fromDate: week.fromDate,
      toDate: week.toDate,
      weeklyProfits: [],
      unassignedAdditions: [],
      unassignedSubtractions: [],
      unassignedOthers: [],
      ericAdditions: [],
      ericSubtractions: [],
      lizAdditions: [],
      lizSubtractions: [],
      ericExtra: { atm: 0, owes: 0 },
      lizCashInHand: 0,
    });

    try {
      // 1️⃣ Fetch saved week from backend
      const res = await axios.post(
    `${BASE_URL}/lizAccounting/getWeek`,
      {
        year: selectedYear,
        month: selectedMonth + 1, // monthIndex 0-11 → 1-12
        weekNumber: week.weekNumber,
      },
      {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      }
    );

      if (res.data.success && res.data.week) {
        // Week exists in DB → load it
        const weekData = res.data.week;
        this.setState({
          ...weekData,
        });
        return;
      }

      // 2️⃣ No saved data → fallback to fetch from locations
      if (locations.length) {
        await this.applyDateRange();
      }

    } catch (err) {
      this.openFeedback('error', `Failed to load week data: ${err.message}`);
    }
  };

  saveWeekData = async () => {
    const { selectedYear, selectedMonth, selectedWeek } = this.state;
    if (!selectedWeek) return;

    const payload = {
      year: selectedYear,
      month: selectedMonth + 1, // store as 1-12
      weekNumber: selectedWeek.weekNumber,
      weeklyProfits: this.state.weeklyProfits,
      unassignedAdditions: this.state.unassignedAdditions,
      unassignedSubtractions: this.state.unassignedSubtractions,
      unassignedOthers: this.state.unassignedOthers,
      ericAdditions: this.state.ericAdditions,
      ericSubtractions: this.state.ericSubtractions,
      lizAdditions: this.state.lizAdditions,
      lizSubtractions: this.state.lizSubtractions,
      fromDate: selectedWeek.fromDate,
      toDate: selectedWeek.toDate,
      ericExtra: this.state.ericExtra,
      lizCashInHand: this.state.lizCashInHand,
    };

    try {
      const res = await axios.post(`${BASE_URL}/lizAccounting/saveWeek`, payload, {
        headers: { Authorization: `Bearer ${this.getToken()}` }
      });

      if (res.data.success) {
        this.openFeedback('success', 'Week saved successfully');
        this.setState({isEditMode: false})
      } else {
        this.openFeedback('error', 'Failed to save week');
      }
    } catch (err) {
      this.openFeedback('error', `Failed to save week: ${err.message}`);
    }
  };


  openYear = (year) => {
    this.setState({
      selectedYear: year,
      selectedMonth: null,
      selectedWeek: null
    });
  };

  openMonth = (monthIndex) => {
    this.setState({
      selectedMonth: monthIndex,
      selectedWeek: null
    });
  };

  openFeedback = (severity, message) => {
    this.setState({
      feedbackBarOpen: true,
      feedbackStatus: severity,
      feedbackMessage: message,
    });
  };

  closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false });
  };

  //APIS
  getToken = () => localStorage.getItem("token");

  fetchLocations = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/location/list`, {
        headers: { Authorization: `Bearer ${this.getToken()}` }
      });
      if (res.data.success) {
        this.setState({ locations: res.data.locations});
      } else {
        this.openFeedback("error", "Failed to fetch locations");
      }
    } catch (err) {
      this.openFeedback("error", `Failed to fetch locations: ${err.message}`);
    }
  };

  applyDateRange = async () => {
      const { selectedWeek, locations } = this.state;
    if (!locations.length) return;

    if (!selectedWeek?.fromDate || !selectedWeek?.toDate) {
      this.openFeedback('error', 'Invalid week date range');
      return;
    }

  const from = format(new Date(selectedWeek.fromDate), 'yyyy-MM-dd');
  const to = format(new Date(selectedWeek.toDate), 'yyyy-MM-dd');

    try {
      const res = await axios.post(
          `${BASE_URL}/lizAccounting/locationSummary`,
          {
            fromDate: from,
            toDate: to,
            locations: locations.map(l => l.name)
          },
          {
            headers: { Authorization: `Bearer ${this.getToken()}` }
          }
      );

      if (!res.data.success) {
        this.openFeedback("error", "Failed to fetch weekly profits");
        return;
      }

      const weeklyProfits = res.data.sessions
          .map(session => {
            const loc = locations.find(
                l => l.name.toUpperCase() === session.locationName.toUpperCase()
            );
            if (!loc) return null;

            const netProfit = session.managerSummary.weeklyNetProfit || 0;

            // ---- Managers & Owners ----
            const managers = loc.investors.filter(i => i.isManager === true);
            const owners = loc.investors.filter(i => !i.isManager);

            // ---- Manager deductions FIRST ----
            let totalManagerShare = 0;
            const managerShares = managers.map(m => {
              const threshold = Number(m.profitThreshold) || 0;
              const pct = Number(m.percentage) || 0;

              // Profit above threshold
              const profitAboveThreshold = Math.max(0, netProfit - threshold);
              const share = (profitAboveThreshold * pct) / 100;

              totalManagerShare += share;

              return {
                investorId: m.investorId,
                share: Number(share.toFixed(2))
              };
            });

            // ---- Remaining profit for owners ----
            const remainingProfit = Math.max(
                0,
                netProfit - totalManagerShare
            );

            // ---- Normalize owner percentages ----
            const totalOwnerPct = owners.reduce(
                (sum, o) => sum + (o.percentage || 0),
                0
            );

            const investors = loc.investors.map(inv => {
              // ---- Manager ----
              if (inv.isManager === true) {
                const mShare =
                    managerShares.find(ms => ms.investorId === inv.investorId)
                        ?.share || 0;

                return {
                  ...inv,
                  share: mShare
                };
              }

              // ---- Owner ----
              const normalizedPct = totalOwnerPct
                  ? inv.percentage / totalOwnerPct
                  : 0;

              return {
                ...inv,
                share: Number(
                    (remainingProfit * normalizedPct).toFixed(2)
                )
              };
            });

            // ---- Attach locationName to unassigned items ----
            const unassignedAdditions =
                (session.managerSummary.adjustments.additions || []).map(a => ({
                  ...a,
                  locationName: session.locationName
                }));

            const unassignedSubtractions =
                (session.managerSummary.adjustments.deductions || []).map(d => ({
                  ...d,
                  locationName: session.locationName
                }));

            const unassignedOthers =
                (session.managerSummary.otherItems || []).map(o => ({
                  ...o,
                  locationName: session.locationName
                }));

            return {
              id: session.readingSessionId,
              locationId: loc.locationId,
              locationName: session.locationName,
              date: new Date(from),
              netProfit,
              investors,
              unassignedAdditions,
              unassignedSubtractions,
              unassignedOthers
            };
          })
          .filter(Boolean);

      // ---- Combine all unassigned adjustments ----
      const allUnassignedAdditions = [];
      const allUnassignedSubtractions = [];
      const allUnassignedOthers = [];

      weeklyProfits.forEach(wp => {
        allUnassignedAdditions.push(...wp.unassignedAdditions);
        allUnassignedSubtractions.push(...wp.unassignedSubtractions);
        allUnassignedOthers.push(...wp.unassignedOthers);
      });

      this.setState({
        weeklyProfits,
        unassignedAdditions: allUnassignedAdditions,
        unassignedSubtractions: allUnassignedSubtractions,
        unassignedOthers: allUnassignedOthers,
        allLocationSummary: res.data.sessions,
        ericAdditions: [],
        ericSubtractions: [],
        lizAdditions: [],
        lizSubtractions: []
      });
    } catch (err) {
      this.openFeedback(
          "error",
          `Failed to fetch weekly profits: ${err.message}`
      );
    }
  };


  //end of apis

  openManualDialog = (type, investor) => {
    this.setState({
      manualDialogOpen: true,
      manualType: type,
      manualDescription: "",
      manualAmount: "",
      selectedInvestor: investor
    });
  };

  closeManualDialog = () => {
    this.setState({ manualDialogOpen: false });
  };

  saveManualEntry = () => {
    const {
      manualType,
      manualDescription,
      manualAmount,
      selectedInvestor,
    } = this.state;

    if (!manualDescription || !manualAmount) return;
    if (!selectedInvestor) return; // no investor selected → do nothing

    const entry = {
      description: manualDescription,
      amount: Number(manualAmount),
      locationName: "",
      isManual: true,
    };


      if (manualType === "ADD") {
        this.setState(prev => ({
          [`${selectedInvestor.toLowerCase()}Additions`]: [...prev[`${selectedInvestor.toLowerCase()}Additions`], entry]
        }));

      }else{
        this.setState(prev => ({
          [`${selectedInvestor.toLowerCase()}Subtractions`]: [...prev[`${selectedInvestor.toLowerCase()}Subtractions`], entry]
        }));
      }



    this.closeManualDialog();
  };

  removeManualEntry = (investor, type, originalIndex) => {
    const key =
      type === "ADD"
        ? `${investor.toLowerCase()}Additions`
        : `${investor.toLowerCase()}Subtractions`;

    this.setState(prev => ({
      [key]: prev[key].filter((_, i) => i !== originalIndex)
    }));
  };

  // Move item to unassigned list (Eric/Liz → Unassigned)
  unassignItem = (investor, type, originalIndex) => {
    const key =
      type === "ADD"
        ? `${investor.toLowerCase()}Additions`
        : `${investor.toLowerCase()}Subtractions`;

    const unassignedKey = type === "ADD" ? "unassignedAdditions" : "unassignedSubtractions";

    this.setState(prev => {
      const item = prev[key][originalIndex];
      const updatedList = prev[key].filter((_, i) => i !== originalIndex);

      return {
        [key]: updatedList,
        [unassignedKey]: [...prev[unassignedKey], { ...item, fromInvestor: investor, type }]
      };
    });
  };


  handleDragEnd = (result) => {
    const { source, destination } = result;

    const getList = (id) => {
      switch (id) {
        case 'unassigned-additions': return [...this.state.unassignedAdditions];
        case 'unassigned-subtractions': return [...this.state.unassignedSubtractions];
        case 'unassigned-others': return [...this.state.unassignedOthers];
        case 'Eric-additions': return [...this.state.ericAdditions];
        case 'Liz-additions': return [...this.state.lizAdditions];
        case 'Eric-subtractions': return [...this.state.ericSubtractions];
        case 'Liz-subtractions': return [...this.state.lizSubtractions];
        default: return [];
      }
    };

    const setList = (id, list) => {
      switch (id) {
        case 'unassigned-additions': this.setState({ unassignedAdditions: list }); break;
        case 'unassigned-subtractions': this.setState({ unassignedSubtractions: list }); break;
        case 'unassigned-others': this.setState({ unassignedOthers: list }); break;
        case 'Eric-additions': this.setState({ ericAdditions: list }); break;
        case 'Liz-additions': this.setState({ lizAdditions: list }); break;
        case 'Eric-subtractions': this.setState({ ericSubtractions: list }); break;
        case 'Liz-subtractions': this.setState({ lizSubtractions: list }); break;
        default: break;
      }
    };

    if (!destination) {
      const sourceId = source.droppableId;

      // already unassigned → nothing to do
      if (sourceId.startsWith('unassigned')) return;

      let targetId = 'unassigned-others';

      if (sourceId.includes('additions')) {
        targetId = 'unassigned-additions';
      } else if (sourceId.includes('subtractions')) {
        targetId = 'unassigned-subtractions';
      }

      const sourceList = getList(sourceId);
      const targetList = getList(targetId);

      const [movedItem] = sourceList.splice(source.index, 1);
      targetList.push(movedItem);

      setList(sourceId, sourceList);
      setList(targetId, targetList);
      return;
    }


    if (source.droppableId === destination.droppableId) {
      const list = getList(source.droppableId);
      const [movedItem] = list.splice(source.index, 1);
      list.splice(destination.index, 0, movedItem);
      setList(source.droppableId, list);
      return;
    }

    const sourceList = getList(source.droppableId);
    const destList = getList(destination.droppableId);

    const [movedItem] = sourceList.splice(source.index, 1);
    destList.splice(destination.index, 0, movedItem);

    setList(source.droppableId, sourceList);
    setList(destination.droppableId, destList);
  };


  assignToInvestor = (item, investorName, type) => {
    if (type === "ADD") {
      this.setState(prev => ({
        unassignedAdditions: prev.unassignedAdditions.filter(i => i !== item),
        [`${investorName.toLowerCase()}Additions`]: [
          ...prev[`${investorName.toLowerCase()}Additions`],
          item
        ]
      }));
    }
    else if (type === "SUB") {
      this.setState(prev => ({
        unassignedSubtractions: prev.unassignedSubtractions.filter(i => i !== item),
        [`${investorName.toLowerCase()}Subtractions`]: [
          ...prev[`${investorName.toLowerCase()}Subtractions`],
          item
        ]
      }));
    }
    else if (type === "OTHER") {
      this.setState(prev => ({
        unassignedOthers: prev.unassignedOthers.filter(i => i !== item),
        [`${investorName.toLowerCase()}Subtractions`]: [
          ...prev[`${investorName.toLowerCase()}Subtractions`],
          item
        ]
      }));
    }
  };

  renderViewMode = (ericProfitShares, lizProfitShares) => {
    return (
        <Grid
            container
            spacing={3}
            wrap="nowrap"
            style={{
              overflowX: 'auto',
            }}
            className="mobile-slider"
        >

          <DragDropContext onDragEnd={this.handleDragEnd}>
            <Grid item xs={12} md={6} className="slider-item">
            <InvestorPanel
                investor="Eric"
                profitShares={ericProfitShares}
                additions={this.state.ericAdditions}
                subtractions={this.state.ericSubtractions}
                onDragEnd={this.handleDragEnd}
                openManualDialog={this.openManualDialog}
                onRemoveManual={this.removeManualEntry}
                ericExtra={this.state.ericExtra}
                updateEricExtra={(newExtra) => {
                  this.setState({ ericExtra: newExtra }, () => {
                    // Recalculate Eric subtotal
                    const ericSubtotal = this.getEricFinalTotals(this.state.ericProfitShares, newExtra).subTotal;
                    this.setState({ ericSubtotal });
                  });
                }}
                // updateEricExtra={(newExtra) => this.setState({ ericExtra: newExtra })}
                updateLizExtra={(cashInHand) => this.setState({ lizCashInHand: cashInHand })}
            />
            </Grid>
            <Grid item xs={12} md={6} className="slider-item">
            <InvestorPanel
                investor="Liz"
                profitShares={lizProfitShares}
                additions={this.state.lizAdditions}
                subtractions={this.state.lizSubtractions}
                onDragEnd={this.handleDragEnd}
                openManualDialog={this.openManualDialog}
                onRemoveManual={this.removeManualEntry}
                isEditMode={this.state.isEditMode}
                ericExtra={this.state.ericExtra} // so Liz panel sees latest Eric extra
                lizCashInHand={this.state.lizCashInHand}
                updateLizExtra={(cashInHand) => this.setState({ lizCashInHand: cashInHand })}
                ericSubtotal={this.getEricFinalTotals(ericProfitShares).subTotal}
            />
            </Grid>
          </DragDropContext>
        </Grid>
    );
  };


  render() {
    const { weeklyProfits } = this.state;


      const lizProfitShares = (weeklyProfits || []).map(w => {
        const inv = w.investors?.find(i => i.name === "Liz");
        return { location: w.locationName, amount: inv?.share ?? 0 };
      });

      const ericProfitShares = (weeklyProfits || []).map(w => {
        const inv = w.investors?.find(i => i.name === "Eric");
        return { location: w.locationName, amount: inv?.share ?? 0 };
      });

    let headerButtons = [];

   if (this.state.selectedWeek || this.state.selectedMonth || this.state.selectedYear) {
    headerButtons.push({
      icon: <KeyboardBackspaceIcon />,
      title: 'Back',
      handler: () => {
        if (this.state.selectedWeek) {
          this.setState({ selectedWeek: null, isEditMode: false });
        } else if (this.state.selectedMonth !== null) {
          this.setState({ selectedMonth: null, isEditMode: false });
        } else if (this.state.selectedYear !== null) {
          this.setState({ selectedYear: null, isEditMode: false });
        }
      }
    });
  } else {
    if (!this.state.isProfitSummary) {
      headerButtons.push({
        icon: <AssessmentIcon />,
        title: 'Profit Summary',
        handler: () => {
          this.setState({ isProfitSummary: true });
        }
      });
    } else {
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        title: 'Back',
        handler: () => {
          this.setState({ isProfitSummary: false });
        }
      });
    }
  }

  if (this.state.selectedWeek && !this.state.isProfitSummary) {


  headerButtons.push({
    icon: <RefreshIcon />, // or any Refresh icon
    title: 'Refresh',
    handler: async () => {
      // Save manual entries before refresh
      this.setState(prev => ({
          savedEricAdditions: prev.ericAdditions.filter(i => i.isManual),
        savedLizAdditions: prev.lizAdditions.filter(i => i.isManual),
        savedEricSubtractions: prev.ericSubtractions.filter(i => i.isManual),
        savedLizSubtractions: prev.lizSubtractions.filter(i => i.isManual),
        refreshDialogOpen: true
      }));
    }
  });

    headerButtons.push({
      icon: this.state.isEditMode ? <VisibilityIcon /> : <EditIcon />,
      title: this.state.isEditMode ? 'Done Editing' : 'Edit',
      handler: () => {
        this.setState(prev => ({ isEditMode: !prev.isEditMode }));
      }
    });
  }


    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
         <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    severity={this.state.feedbackStatus}
                    message={this.state.feedbackMessage}
                    handleClose={this.closeFeedbackBar}
                />
        <CustomToolbar
            title={
                this.state.isProfitSummary
                  ? "Profit Summary"
                  : this.state.selectedWeek
                  ? `Week of ${format(this.state.selectedWeek.fromDate, 'MMM d, yyyy')}`
                  : this.state.selectedMonth !== null
                  ? `${MONTHS[this.state.selectedMonth]} ${this.state.selectedYear}`
                  : this.state.selectedYear !== null
                  ? `Year ${this.state.selectedYear}`
                  : "Liz Accounting"
            }
            headerButtons={headerButtons}
        />

        <div className="root">

          {this.state.isProfitSummary ?
           <ProfitSummary

                />
          :
          <>

            {!this.state.selectedYear && (
              <Grid container spacing={4}>
                {this.state.YEARS.map(year => (
                  <Grid item xs={12} sm={6} md={3} key={year}>
                    <FolderCard
                      title={year}
                      subtitle="Accounting Year"
                      variant="year"
                      onClick={() => this.openYear(year)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}


          {this.state.selectedYear !== null && this.state.selectedMonth === null && (
            <Grid container spacing={3}>
              {MONTHS.map((month, idx) => (
                <Grid item xs={12} sm={6} md={3} key={month}>
                  <FolderCard
                    title={month}
                    subtitle="Accounting Month"
                    variant="month"
                    onClick={() => this.openMonth(idx)}
                  />
                </Grid>
              ))}
            </Grid>
          )}

          {this.state.selectedYear !== null &&
             this.state.selectedMonth !== null &&
             !this.state.selectedWeek && (
              <Grid container spacing={3}>
                {this.generateWeeksForMonth(
                  this.state.selectedYear,
                  this.state.selectedMonth
                ).map(week => (
                  <Grid item xs={12} sm={6} md={4} key={week.weekNumber}>
                   <FolderCard
                    title={week.label}
                    subtitle="Accounting Week"
                    variant="week"
                    onClick={() => this.openWeek(week)}
                  />
                  </Grid>
                ))}
              </Grid>
            )}
          </>
          }

          <Dialog
  open={this.state.refreshDialogOpen}
  onClose={() => this.setState({ refreshDialogOpen: false })}
>
  <DialogTitle>Refresh Week Data?</DialogTitle>
  <DialogContent>
    <Typography>
      This will fetch the latest updates from the location summary. Any unsaved manual changes will be lost.
    </Typography>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => this.setState({ refreshDialogOpen: false })}>Cancel</Button>
    <Button
      color="primary"
      variant="contained"

       onClick={async () => {
        this.setState({ refreshDialogOpen: false });
        await this.applyDateRange(); // fetch latest locationSummary

        // Restore manual entries
        this.setState(prev => ({
          ericAdditions: [...prev.ericAdditions, ...prev.savedEricAdditions],
          lizAdditions: [...prev.lizAdditions, ...prev.savedLizAdditions],
          ericSubtractions: [...prev.ericSubtractions, ...prev.savedEricSubtractions],
          lizSubtractions: [...prev.lizSubtractions, ...prev.savedLizSubtractions],

          // Clear saved manual entries
          savedEricAdditions: [],
          savedLizAdditions: [],
          savedEricSubtractions: [],
          savedLizSubtractions: [],
        }));

        this.openFeedback('success', 'Week data refreshed!');
      }}

    >
      Refresh
    </Button>
  </DialogActions>
</Dialog>


          <Dialog
              open={this.state.manualDialogOpen}
              onClose={this.closeManualDialog}
          >
            <DialogTitle>
              {this.state.manualType === "ADD" && "Add Manual Addition"}
              {this.state.manualType === "SUB" && "Add Manual Subtraction"}
              {this.state.manualType === "OTHER" && "Add Manual Removal"}
            </DialogTitle>

            <DialogContent>
              <TextField
                  fullWidth
                  variant="outlined"
                  label="Description"
                  value={this.state.manualDescription}
                  onChange={(e) => this.setState({ manualDescription: e.target.value })}
                  style={{ marginBottom: 16 }}
              />
              <TextField
                  variant="outlined"
                  fullWidth
                  type="number"
                  label="Amount"
                  value={this.state.manualAmount}
                  onChange={(e) => this.setState({ manualAmount: e.target.value })}
              />
            </DialogContent>

            <DialogActions style={{margin:'16px'}}>
              <Button onClick={this.closeManualDialog}>Cancel</Button>
              <Button color="primary" variant="contained" onClick={this.saveManualEntry}>
                Save
              </Button>
            </DialogActions>
          </Dialog>

        {this.state.selectedWeek && this.state.weeklyProfits?.length > 0 && (
          <div>
          {this.state.isEditMode ? (
              <DragDropContext onDragEnd={this.handleDragEnd}>

                {/* Unassigned Additions */}
                <Droppable droppableId="unassigned-additions">
                  {(provided) => (
                      <Box
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="section-box add-box"
                      >
                        <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>
                          Unassigned Additions
                        </Typography>
                        <div className="unassigned-container">
                        {this.state.unassignedAdditions.map((item, index) => (

                            <Draggable
                                key={`unassigned-add-${index}`}
                                draggableId={`unassigned-add-${index}`}
                                index={index}
                            >
                              {(dragProvided) => (
                                  <Box
                                      ref={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                      {...dragProvided.dragHandleProps}
                                      className="unassigned-card"
                                      style={dragProvided.draggableProps.style}
                                  >
                                    <Typography>{item.description} ({item.locationName})</Typography>
                                    <Typography>${item.amount.toLocaleString()}</Typography>

                                    <div className="unassigned-card-actions">
                                      <Button size="small" variant="contained" color="primary"
                                              onClick={() => this.assignToInvestor(item, "Eric", "ADD")}>E</Button>
                                      <Button size="small" variant="contained" color="secondary"
                                              onClick={() => this.assignToInvestor(item, "Liz", "ADD")}>L</Button>
                                    </div>

                                  </Box>
                              )}
                            </Draggable>
                        ))}
                        </div>

                        {provided.placeholder}

                      </Box>
                  )}
                </Droppable>

                {/* Unassigned Subtractions */}
                <Droppable droppableId="unassigned-subtractions">
                  {(provided) => (
                      <Box
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="section-box add-box"
                      >
                        <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>
                          Unassigned Subtractions
                        </Typography>

                        <div className="unassigned-container">
                        {this.state.unassignedSubtractions.map((item, index) => (
                            <Draggable
                                key={`unassigned-sub-${index}`}
                                draggableId={`unassigned-sub-${index}`}
                                index={index}
                            >
                              {(dragProvided) => (
                                  <Box
                                      ref={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                      {...dragProvided.dragHandleProps}
                                      className="unassigned-card"
                                      style={dragProvided.draggableProps.style}
                                  >
                                    <Typography>{item.description} ({item.locationName})</Typography>
                                    <Typography>${item.amount.toLocaleString()}</Typography>

                                    <div className="unassigned-card-actions">
                                      <Button size="small" variant="contained" color="primary"
                                              onClick={() => this.assignToInvestor(item, "Eric", "SUB")}>E</Button>
                                      <Button size="small" variant="contained" color="secondary"
                                              onClick={() => this.assignToInvestor(item, "Liz", "SUB")}>L</Button>
                                    </div>

                                  </Box>
                              )}
                            </Draggable>
                        ))}
                        </div>
                        {provided.placeholder}

                      </Box>
                  )}
                </Droppable>


                {/* Unassigned Others */}
                <Droppable droppableId="unassigned-others">
                  {(provided) => (
                      <Box
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="section-box add-box"
                      >
                        <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>
                          Unassigned Others
                        </Typography>
                        <div className="unassigned-container">
                          {this.state.unassignedOthers.map((item, index) => (
                            <Draggable
                                key={`unassigned-other-${index}`}
                                draggableId={`unassigned-other-${index}`}
                                index={index}
                            >
                              {(dragProvided) => (
                                  <Box
                                      ref={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                      {...dragProvided.dragHandleProps}
                                      className="unassigned-card"
                                      style={dragProvided.draggableProps.style}
                                  >
                                    <Typography>{item.description} ({item.locationName})</Typography>
                                    <Typography>${item.amount.toLocaleString()}</Typography>

                                    <div className="unassigned-card-actions">
                                      <Button size="small" variant="contained" color="primary"
                                              onClick={() => this.assignToInvestor(item, "Eric", "OTHER")}>E</Button>
                                      <Button size="small" variant="contained" color="secondary"
                                              onClick={() => this.assignToInvestor(item, "Liz", "OTHER")}>L</Button>
                                    </div>

                                  </Box>
                              )}
                            </Draggable>
                        ))}
                        </div>
                        {provided.placeholder}

                      </Box>
                  )}
                </Droppable>

                {/* Investor Panels */}
                <Grid
                    container
                    spacing={3}
                    wrap="nowrap"
                    style={{
                      overflowX: 'auto',
                    }}
                    className="mobile-slider"
                >
                  <Grid item xs={12} md={6} className="slider-item">
                  <InvestorPanel
                      investor="Eric"
                      profitShares={ericProfitShares}
                      additions={this.state.ericAdditions}
                      subtractions={this.state.ericSubtractions}
                      onDragEnd={this.handleDragEnd}
                      openManualDialog={this.openManualDialog}
                      onRemoveManual={this.removeManualEntry}
                      isEditMode={this.state.isEditMode}
                      ericExtra={this.state.ericExtra}
                      updateEricExtra={(newExtra) => {
                        this.setState({ ericExtra: newExtra }, () => {
                          // Recalculate Eric subtotal
                          const ericSubtotal = this.getEricFinalTotals(this.state.ericProfitShares, newExtra).subTotal;
                          this.setState({ ericSubtotal });
                        });
                      }}
                      updateLizExtra={(cashInHand) => this.setState({ lizCashInHand: cashInHand })}
                      onUnassignItem={this.unassignItem}
                  />
                  </Grid>
                  <Grid item xs={12} md={6} className="slider-item">
                  <InvestorPanel
                      investor="Liz"
                      profitShares={lizProfitShares}
                      additions={this.state.lizAdditions}
                      subtractions={this.state.lizSubtractions}
                      onDragEnd={this.handleDragEnd}
                      openManualDialog={this.openManualDialog}
                      onRemoveManual={this.removeManualEntry}
                      isEditMode={this.state.isEditMode}
                      ericExtra={this.state.ericExtra} // so Liz panel sees latest Eric extra
                      lizCashInHand={this.state.lizCashInHand}
                      updateLizExtra={(cashInHand) => this.setState({ lizCashInHand: cashInHand })}
                      ericSubtotal={this.getEricFinalTotals(ericProfitShares).subTotal}
                      onUnassignItem={this.unassignItem}

                  />
                  </Grid>
                </Grid>

              </DragDropContext>
              ) :
                this.renderViewMode(ericProfitShares, lizProfitShares)
              }

          {this.state.isEditMode && this.state.selectedWeek && this.state.weeklyProfits?.length > 0 && (
                <div className="action-bar">
                  <Button
                      variant="outlined"
                      onClick={() => this.setState({ selectedWeek: null, isEditMode: false })}
                      className="action-btn cancel-btn"
                  >
                    Cancel
                  </Button>

                  <Button
                      variant="contained"
                      color="primary"
                      onClick={this.saveWeekData}
                      className="action-btn save-btn"
                  >
                    Save
                  </Button>
                </div>
            )}

          </div>
        )}




        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = state => ({userInfo: userInfoSelector(state)});


export default withShipment({
  mapStateToProps,
}, LizAccounting);
